export const USER_DATA_LOCALSTORAGE = 'USER_DATA';
export const USER_TOKEN_LOCALSTORAGE = 'USER_TOKEN';
export const ENROLL_COURSE_ONBOARDING_LOCALSTORAGE = 'COURSE_ONBOARDING';
export const USER_PARTNER_TOKEN_LOCALSTORAGE = 'USER_PARTNER_TOKEN';

export const setUserData = (data) => {
  localStorage.setItem(USER_DATA_LOCALSTORAGE, JSON.stringify(data));
};

export const getUserData = () => {
  return JSON.parse(localStorage.getItem(USER_DATA_LOCALSTORAGE));
};

export const setUserToken = (data) => {
  localStorage.setItem(USER_TOKEN_LOCALSTORAGE, JSON.stringify(data));
};

export const getUserToken = () => {
  return JSON.parse(localStorage.getItem(USER_TOKEN_LOCALSTORAGE));
};

// export const setEnrollCourseOnBoarding = (data) => {
//   localStorage.setItem(ENROLL_COURSE_ONBOARDING_LOCALSTORAGE, JSON.stringify(data));
// };

// export const getEnrollCourseOnboarding = () => {
//   return JSON.parse(localStorage.getItem(ENROLL_COURSE_ONBOARDING_LOCALSTORAGE));
// };

// export const setUserPartnerToken = (data) => {
//   localStorage.setItem(USER_PARTNER_TOKEN_LOCALSTORAGE, JSON.stringify(data));
// };

// export const getUserPartnerToken = () => {
//   return JSON.parse(localStorage.getItem(USER_PARTNER_TOKEN_LOCALSTORAGE));
// };

